export default __webpack_public_path__ + "static/media/PopupIcons_View_Daily_Balance_Grey.4539d7c5.svg";